define('plugin/gallery/controller/GalleryController',['require','lib/controller/BaseController','plugin/gallery/view/GalleryIndexView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var GalleryIndexView = require('plugin/gallery/view/GalleryIndexView');

    /**
     * Gallery Controller
     *
     * @class GalleryController
     */
    return BaseController.extend({

        _collection: null,

        initialize: function () {
            this._collection = this.getOption('galleryCollection');
            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of images
         */
        index: function() {
            var indexView = new GalleryIndexView({
                collection: this._collection
            });

            this._collection.load();

            this.getMainLayout().getContentRegion().show(indexView);
        }

    });

});
